import { render, staticRenderFns } from "./Dialog_ClassHourRetired.vue?vue&type=template&id=6cce2955&scoped=true&"
import script from "./Dialog_ClassHourRetired.vue?vue&type=script&lang=js&"
export * from "./Dialog_ClassHourRetired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cce2955",
  null
  
)

export default component.exports